export const NOTIFICATION_ENDPOINTS = {
  LIST: '/customer/notification/',
  CHECK: '/customer/notification/check/',
  STREAM: '/customer/notification/stream/',
  MARK_READ: '/customer/notification/mark-read/',
} as const
